<dac-navbar [doubleNav]="false"></dac-navbar>
<div class="container pt-5 pb-5 mb-5">
  <div class="row">
    <div class="col">
      <h1 class='text-center'>Business Associate Agreement</h1>

      <h2>Definitions</h2>
      <u>Catch-all definition:</u>
      <p>The following terms used in this Agreement shall have the same meaning as those terms in the HIPAA Rules:
        Breach, Data
        Aggregation, Designated Record Set, Disclosure, Health Care Operations, Individual, Minimum Necessary, Notice of
        Privacy
        Practices, Protected Health Information, Required By Law, Secretary, Security Incident, Subcontractor, Unsecured
        Protected Health Information, and Use.</p>

      <u>Specific definitions:</u>
      <ol type="a">
        <li><u>Business Associate</u>. “Business Associate” shall generally have the same meaning as the term “business
          associate” at
          45 CFR 160.103, and in reference to the party to this agreement, shall mean Discover and Change, Inc.</li>
        <li><u>Covered Entity</u>. “Covered Entity” shall generally have the same meaning as the term “covered entity”
          at 45 CFR
          160.103, and in reference to the party to this agreement, shall mean active subscriber to Discover and Change,
          Inc.
        </li>
        <li><u>HIPAA Rules</u>. “HIPAA Rules” shall mean the Privacy, Security, Breach Notification, and Enforcement
          Rules at 45 CFR
          Part 160 and Part 164.</li>
          <li><u>Minimum Necessary</u> “Minimum Necessary” shall mean the Privacy Rule Standards found at 45 CFR 164.502(b) and 164.514(d)(1).</li>
      </ol>
      <h2>Obligations and Activities of Business Associate</h2>
      Business Associate agrees to:
      <ol type='a'>
        <li> Not use or disclose protected health information other than as permitted or required by the Agreement or as
          required by law;</li>
        <li> Use appropriate safeguards, and comply with Subpart C of 45 CFR Part 164 with respect to electronic
          protected
          health information, to prevent use or disclosure of protected health information other than as provided for by
          the
          Agreement;</li>
        <li> Report to covered entity any use or disclosure of protected health information not provided for by the
          Agreement
          of which it becomes aware, including breaches of unsecured protected health information as required at 45 CFR
          164.410, and any security incident of which it becomes aware;</li>

        <li> In accordance with 45 CFR 164.502(e)(1)(ii) and 164.308(b)(2), if applicable, ensure that any
          subcontractors that
          create, receive, maintain, or transmit protected health information on behalf of the business associate agree
          to the
          same restrictions, conditions, and requirements that apply to the business associate with respect to such
          information;</li>
        <li> Make available protected health information in a designated record set to the “covered entity” as necessary
          to
          satisfy covered entity’s obligations under 45 CFR 164.524;</li>

        <li> Forward direct requests from individuals to the business associate for access to the designated record set
          onto
          the covered entity connected with the designated record set for that individual;</li>
        <li> Make any amendment(s) to protected health information in a designated record set as directed or agreed to
          by the
          covered entity pursuant to 45 CFR 164.526, or take other measures as necessary to satisfy covered entity’s
          obligations under 45 CFR 164.526;</li>

        <li> Forward direct requests from individuals to the business associate to make amendment(s) to protected health
          information onto the covered entity whose protected health information is connected to the individual;</li>
        <li> Maintain and make available the information required to provide an accounting of disclosures to the
          “covered entity” as necessary to satisfy covered entity’s obligations under 45 CFR 164.528;
        </li>
        <li> Forward direct accounting of disclosure requests from individuals to the business associate onto the
          covered
          entity whose protected health information is connected to the individual(s);</li>

        <li> To the extent the business associate is to carry out one or more of covered entity's obligation(s) under
          Subpart
          E of 45 CFR Part 164, comply with the requirements of Subpart E that apply to the covered entity in the
          performance
          of such obligation(s); and</li>
        <li> Make its internal practices, books, and records available to the Secretary for purposes of determining
          compliance
          with the HIPAA Rules.</li>
      </ol>
      <h2>Permitted Uses and Disclosures by Business Associate</h2>
      <ol type='a'>
        <li> Business associate may only use or disclose protected health information


          We will use the data as necessary to perform the services set forth in our Terms and Conditions agreement.
          In accordance with 45 CFR 164.514(a)-(c), protected health information will be de-identified and aggregated by
          Business Associate. This aggregated information will be used to assist Business associate in managing,
          administering, performing legal duties as required by law, and improving the products and services for current
          and
          future customers of the business associate.
          Additionally, some products and services will obtain permission from individuals of covered entities to
          utilized
          individual’s de-identified protected health information in a limited data set for public health research
          purposes
          according to 45 CFR 164.514(e).</li>


        <li> Business associate may use or disclose protected health information as required by law.</li>

        <li> Business associate may not use or disclose protected health information in a manner that would violate
          Subpart E
          of 45 CFR Part 164 if done by covered entity except for the specific uses and disclosures set forth below.
        </li>
        <li> Business associate may use protected health information for the proper management and administration of the
          business associate or to carry out the legal responsibilities of the business associate.</li>
        <li> Business associate may disclose protected health information for the proper management and administration
          of
          business associate or to carry out the legal responsibilities of the business associate, provided the
          disclosures
          are required by law, or business associate obtains reasonable assurances from the person to whom the
          information is
          disclosed that the information will remain confidential and used or further disclosed only as required by law
          or for
          the purposes for which it was disclosed to the person, and the person notifies business associate of any
          instances
          of which it is aware in which the confidentiality of the information has been breached.</li>
        <li> Business associate may provide data aggregation services relating to the health care operations of the
          covered
          entity.</li>
          <li> Business associate agrees to make uses, disclosures, and requests for protected health information
            consistent with the Minimum Necessary principle as defined in this agreement.</li>
      </ol>
      <h2>Provisions for Covered Entity to Inform Business Associate of Privacy Practices and Restrictions</h2>
      <ol type='a'>
        <li> Covered entity shall notify business associate of any limitation(s) in the notice of privacy practices of
          covered
          entity under 45 CFR 164.520, to the extent that such limitation may affect business associate’s use or
          disclosure of
          protected health information.</li>
        <li> Covered entity shall notify business associate of any changes in, or revocation of, the permission by an
          individual to use or disclose his or her protected health information, to the extent that such changes may
          affect
          business associate’s use or disclosure of protected health information.</li>
        <li> Covered entity shall notify business associate of any restriction on the use or disclosure of protected
          health
          information that covered entity has agreed to or is required to abide by under 45 CFR 164.522, to the extent
          that
          such restriction may affect business associate’s use or disclosure of protected health information.</li>
      </ol>
      <h2>Permissible Requests by Covered Entity</h2>
      Covered entity shall not request business associate to use or disclose protected health information in any manner
      that
      would not be permissible under Subpart E of 45 CFR Part 164 if done by covered entity.
      <h2>Term and Termination</h2>
      <ol type='a'>
        <li> Term. The Term of this Agreement shall be effective as of the date and time Covered Entity agrees to the
          Terms of Services for using
          Discover and Change's Website, Software, and Services, and shall terminate when all of the Protected Health
          Information provided by Covered
          Entity to Business Associate, or created or received by Business Associate on behalf of Covered Entity, is
          destroyed or returned to Covered Entity.
          If it is infeasible to return or destroy Protected Health Information, protections are extended to such
          information, in accordance with the termination
          provisions of this Agreement.</li>
        <li>Termination for Cause by Covered Entity. Business associate authorizes termination of this Agreement by
          covered entity, if covered
          entity determines business associate has violated a material term of the Agreement and business associate has
          not
          cured the breach or ended the violation within the time specified by covered entity.</li>
        <li>Termination for Cause by Business Associate. Upon Business Associate's knowledge of a material breach of
          this Agreement by Covered Entity, Business Associate
          will give Covered Entity notice via email of such breach and provide Covered Entity reasonable opportunity to
          cure the breach or end the violation. Business Associate
          may terminate this Agreement, and Covered Entity agrees to such termination, if Covered Entity has breached a
          material term of this Agreement and does not cure the breach or
          the cure is not possible. If neither termination or cure is feasible, Business Associate shall report the
          violation to the Secretary.
        </li>
        <li> Obligations of Business Associate Upon Termination.
          Upon termination of this Agreement for any reason, business associate, with respect to protected health
          information
          received from covered entity, or created, maintained, or received by business associate on behalf of covered
          entity,
          shall:
          <ol>
            <li>Retain only that protected health information which is necessary for business associate to continue its
              proper
              management and administration or to carry out its legal responsibilities;</li>
            <li> Return to covered entity or, if agreed to by covered entity, destroy the remaining protected health
              information that the business associate still maintains in any form;</li>
            <li> Continue to use appropriate safeguards and comply with Subpart C of 45 CFR Part 164 with respect to
              electronic protected health information to prevent use or disclosure of the protected health information,
              other
              than as provided for in this Section, for as long as business associate retains the protected health
              information;</li>
            <li> Not use or disclose the protected health information retained by business associate other than for the
              purposes for which such protected health information was retained and subject to the same conditions set
              out at
              paragraphs (e) and (f) above under “Permitted Uses and Disclosures By Business Associate” which applied
              prior to
              termination; and</li>
            <li> Return to covered entity or, if agreed to by covered entity, destroy the protected health information
              retained by business associate when it is no longer needed by business associate for its proper management
              and
              administration or to carry out its legal responsibilities.</li>
          </ol>

        </li>
        <li>Survival. The obligations of business associate under this Section shall survive the termination of this
          Agreement.</li>
      </ol>
      <h2>Miscellaneous</h2>
      <ol type='a'>
        <li> Regulatory References. A reference in this Agreement to a section in the HIPAA Rules means the section as
          in
          effect or as amended.</li>
        <li> Amendment. The Parties agree to take such action as is necessary to amend this Agreement from time to time
          as is
          necessary for compliance with the requirements of the HIPAA Rules and any other applicable law.</li>
        <li> Interpretation. Any ambiguity in this Agreement shall be interpreted to permit compliance with the HIPAA
          Rules.
        </li>
      </ol>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/baa/baa.component.html